<template>
  <ClientModal @close-modal="$emit('close-modal', true)">
    <template #header>
      {{ $t('client.title_contacts') }}
    </template>
    <div class="contact_infos">
      <div
        class="contact_infos__item"
        v-if="settings.show_phone_for_client == 1"
      >
        <div class="contact_infos__label">{{$t('client.index.have_questions')}}</div>
        <div class="contact_infos__value">{{ settings.phone_for_client }}</div>
      </div>
      <div
        class="contact_infos__item"
        v-if="settings.show_contact_company == 1"
      >
        <div class="contact_infos__label">{{$t('client.contact_company')}}:</div>
        <div class="contact_infos__value">{{ settings.company_name }}</div>
      </div>
      <div
        class="contact_infos__item"
        v-if="settings.show_contact_inn == 1"
      >
        <div class="contact_infos__label">{{$t('client.contact_inn')}}:</div>
        <div class="contact_infos__value">{{ settings.company_inn }}</div>
      </div>
      <div
        class="contact_infos__item"
        v-if="settings.show_contact_address == 1"
      >
        <div class="contact_infos__label">{{$t('client.contact_address')}}:</div>
        <div class="contact_infos__value">{{ settings.company_address }}</div>
      </div>
      <div
        class="contact_infos__item"
        v-if="settings.show_contact_phone == 1||settings.show_contact_phone_city==1"
      >
        <div class="contact_infos__label">{{$t('client.contact_phone')}}:</div>
        <div
          class="contact_infos__value"
          v-if="settings.show_contact_phone == 1||settings.show_contact_phone==1"
        >{{ settings.company_phone }}</div>
        <div
          class="contact_infos__value"
          v-if="settings.show_contact_phone_city==1"
        >{{ settings.company_phone_cities }}</div>
      </div>
      <div
        class="contact_infos__item"
        v-if="settings.show_contact_email== 1"
      >
        <div class="contact_infos__label">{{$t('client.contact_email')}}:</div>
        <div class="contact_infos__value">{{ settings.company_email}}</div>
      </div>
    </div>

  </ClientModal>
</template>
<script>
export default {
  name: "ContactsModal",
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
  },
};
</script>
<style scoped>
.contact_infos {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  color: #3b4450;
}
.contact_infos__label {
  font-size: 12px;
}
.contact_infos__value {
  font-size: 22px;
}
</style>
